import React, { FC, useContext } from 'react';
import { PrintActionButton } from '../../../components/sub-header/actions/PrintActionButton';
import { ShareActionButton } from '../../../components/sub-header/actions/ShareActionButton';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { detectUserAgent } from '../../../utils/userAgentUtils';
import { UserContext } from '../../../user/UserContext';
import { LawyerContext } from '../LawyerContext';

type Props = {
  source: string;
};

export const LawyerActions: FC<Props> = ({ source }) => {
  const { accessPremium } = useContext(UserContext);
  const { lawyerName } = useContext(LawyerContext);
  const textToCopy = () => {
    const profileUrl = `${window.location.origin}${window.location.pathname}`;
    return `Page professionnelle de Maître ${lawyerName}. Voir en ligne : ${profileUrl}`;
  };

  const sendPrintAnalytics = () =>
    doctrineAnalytics('Lawyer ButtonPrintClicked');

  const sendShareAnalytics = () =>
    doctrineAnalytics('Lawyer ButtonCopyClicked');

  return (
    <div className="button-group no-gaps clear secondary">
      {detectUserAgent() !== 'Mozilla Firefox' && (
        <PrintActionButton
          source={source}
          accessPremium={accessPremium}
          sendAnalytics={sendPrintAnalytics}
        />
      )}
      <ShareActionButton
        source={source}
        text={textToCopy()}
        sendAnalytics={sendShareAnalytics}
      />
    </div>
  );
};
